/* eslint-disable eqeqeq */
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import RequireAuth from "./components/RequireAuth";
import Layout from "./components/UI/Layout";
import HomePage from "./components/HomePage";
import { useGetAllTabsUserHasAccessToQuery, useGetIfUserIsAdminQuery } from "./redux/api/user";
import SettingsPage from "./components/Settings/SettingsPage";
import SettingsLandingPageContainer from "./containers/SettingsLandingPageContainer";
import AdminSettingsPage from "./components/Settings/AdminSettingsPage";
// import OverviewPage from "./components/Performance/OverviewPage";
import ROUTE_CONFIG from "./routes/RouteConfig";
import { useMemo } from "react";
import { NotificationProvider } from "./hooks/useNotification";
import DropdownGroupProvider from "./hooks/useUpdateDropdownGroups";

function App() {
  const allowedTabs = useGetAllTabsUserHasAccessToQuery();
  const { data: isAdmin } = useGetIfUserIsAdminQuery();
  const routes = useMemo(() => {
    if (!allowedTabs.data) return [];

    return allowedTabs.data
      .flatMap((tab) => {
        const config = ROUTE_CONFIG[tab];
        return Array.isArray(config) ? config : [config];
      })
      .filter(Boolean);
  }, [allowedTabs.data]);

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <BrowserRouter>
        <NotificationProvider>
          <DropdownGroupProvider>
            <Layout>
              <RequireAuth>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/legacy_settings" element={<SettingsPage />} />
                  <Route path="/settings" element={<SettingsLandingPageContainer />} />
                  {/* Redirect old budget planner paths to new target settings */}
                  <Route path="/budget-planner" element={<Navigate to="/target-settings" replace />} />
                  <Route path="/settings/budget-planner" element={<Navigate to="/settings/target-settings" replace />} />
                  {/* mapping for routes that need an allowed permission */}
                  {routes.map(({ path, element: Element }) => (
                    <Route key={path} path={path} element={<Element />} />
                  ))}
                  {isAdmin && (
                    <Route path="/settings/admin" element={<AdminSettingsPage />} />
                  )}
                </Routes>
              </RequireAuth>
            </Layout>
          </DropdownGroupProvider>
        </NotificationProvider>
      </BrowserRouter>
    </Auth0Provider>
  );
}

export default App;
